import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFieldArray, useForm } from "react-hook-form";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { FormInput } from "../../../components/molecules/FormInput";
import { actualizarIdioma, getAllIdiomas, getAllIdiomasByIdNivel, getOneIdioma } from "../../../services/idioma.service";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
const buttonStyle = {
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  };
  const saveButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#4CAF50",
  };
  
  const cancelButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#f44336",
  };
  
export const ActualizarIdiomaPage = () => {
    const { idIdioma } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        idPrograma: "",
        nombre: "",
        sigla: "",
    });
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getOneIdioma(idIdioma);
                setFormData({
                    idIdioma: data.idIdioma,
                    nombre: data.nombre,
                    sigla: data.sigla,
                });
            } catch (err) {
                setError("No se pudieron cargar los datos. Por favor, verifica el servidor.");
                console.error(err);
            }

        };
        fetchData();
    }, [idIdioma]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(`Campo cambiado: ${name}, Valor: ${value}`);
        setFormData({ ...formData, [name]: value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await actualizarIdioma(formData.idIdioma, formData);

            showAlert({
                title: "¡Actualizado correctamente!",
                text: "Los datos del programa han sido actualizados correctamente.",
                callback: () => {
                    navigate("/idiomas");
                },
            });
        } catch (err) {

            if (err.response && err.response.data.errors) {
                const mensajes = Object.values(err.response.data.errors).flat();
                showErrorAlert("Errores de validación:\n" + mensajes.join("\n"));
            } else {
                showErrorAlert("Ocurrió un error inesperado.");
            }
        }
    };
    if (error) {
        return <p style={{ color: "red" }}>{error}</p>;
    }
    const handleCancel = () => {
        navigate("/idiomas");
    };
    return (
        <ContenedorPageTemplate titulo={`Actualizar datos del Idioma: `}>
            <form
                onSubmit={handleSubmit}
                style={{
                    maxWidth: "600px",
                    margin: "0 auto",
                    padding: "20px",
                    background: "#f9f9f9",
                    borderRadius: "8px",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)"
                }}>
                <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "5px" }}>Nombre del Idioma:</label>
                    <input
                        type="text"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                    />
                </div>
                <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "5px" }}>Sigla:</label>
                    <input
                        type="text"
                        name="sigla"
                        value={formData.sigla}
                        onChange={handleChange}
                        style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <button
                        type="submit"
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                        }}
                    >
                        Guardar cambios
                    </button>
                    <button type="button" style={cancelButtonStyle} onClick={handleCancel}>
                        Cancelar
                    </button>
                </div>
            </form>
        </ContenedorPageTemplate>
    );
};
